<template>
  <div class="w-10/12 mx-auto">
    <div
      class="flex flex-col space-y-16 lg:flex-row lg:space-x-20 lg:space-y-0"
    >
      <div class="lg:w-6/12">
        <h2 class="mb-10 font-serif text-3xl lg:leading-tight lg:text-5xl">
          {{ servicesData.title }}
        </h2>
        <ul
          class="flex flex-col mb-10 space-y-5 lg:space-x-10 lg:flex-row lg:space-y-0"
        >
          <li
            v-for="(tab, index) in servicesData.tabs"
            :key="index"
          >
            <a
              href="#"
              :class="`text-base tracking-wider uppercase btn-link ${
                index === activeTab ? 'is-line' : 'opacity-50 hover:opacity-100'
              }`"
              @click.prevent.stop="setTab(index)"
            >{{ tab.title }}</a>
          </li>
        </ul>

        <transition name="tab">
          <template v-if="showTab">
            <div>
              <div
                class="font-light post lg:max-w-lg"
                v-html="servicesData.tabs[activeTab].description"
              />

              <a
                v-if="
                  servicesData.tabs[activeTab].button.label &&
                    servicesData.tabs[activeTab].button.link
                "
                :href="servicesData.tabs[activeTab].button.link"
                class="inline-block mt-10 btn btn-danger"
              >
                {{ servicesData.tabs[activeTab].button.label }}
              </a>
            </div>
          </template>
        </transition>
      </div>

      <div class="lg:w-6/12">
        <div class="relative group">
          <div class="aspect-ratio-4/3" />
          <div class="absolute top-0 left-0 z-10 w-full h-full">
            <div
              class="absolute top-0 left-0 z-0 w-full h-full -m-5 lg:-m-10 bg-brand-500"
            />
            <img
              v-if="!servicesData.tabs[activeTab].use_video"
              :data-src="servicesData.tabs[activeTab].image.sizes.medium"
              class="absolute top-0 left-0 z-10 object-cover object-center w-full h-full lazy"
            >

            <transition name="tab">
              <template
                v-if="servicesData.tabs[activeTab].use_video && showTab"
              >
                <div
                  id="player"
                  class="w-full h-full plyr__video-embed"
                >
                  <iframe
                    class="absolute top-0 left-0 z-10 w-full h-full"
                    :src="`https://www.youtube.com/embed/${youtubeParser(
                      servicesData.tabs[activeTab].video
                    )}?origin=https://plyr.io&amp;iv_load_policy=3&amp;listType=user_uploads&amp;controls=0&amp;fs=0&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`"
                    allowfullscreen
                    allowtransparency
                    allow="autoplay"
                  />
                </div>
              </template>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Plyr from "plyr";
import LazyLoad from "vanilla-lazyload";

export default {
  components: {},
  data() {
    return {
      activeTab: 0,
      showTab: true,
      player: false,
      servicesData: window.servicesData,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    youtubeParser(url) {
      const regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    },
    setTab(index) {
      this.activeTab = index;
      this.showTab = false;
      setTimeout(() => {
        this.showTab = true;
      }, 200);
      this.$nextTick(() => {
        this.init();
      });
    },
    init() {
      new LazyLoad({
        elements_selector: ".lazy",
        unobserve_entered: true,
      });

      this.player = new Plyr("#player", {
        controls: [
          "play-large",
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
          "fullscreen",
        ],
      });
    },
  },
};
</script>

<style>
.tab-enter-active,
.tab-leave-active {
  @apply transition-opacity duration-200;
}
.tab-enter,
.tab-leave-to {
  @apply opacity-0;
}

.plyr--video {
  @apply h-full;
}

.plyr.plyr--stopped .plyr__controls {
  display: none;
}
</style>
